exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog_buttons[data-v-a7ba5fd4]{display:flex;justify-content:space-between;padding:1.2rem}.dialog_columns[data-v-a7ba5fd4],.dialog_title[data-v-a7ba5fd4]{display:block}", ""]);

// exports
